import { defineStore } from "pinia";
import axios from "@/api/axios";
import {EventLogResponse} from "@/types/events";

export const useEventLogStore = defineStore("EventLogStore", {
  state: () => ({
    eventsLog: {} as EventLogResponse,
    isLoadingEventsLog: false as boolean,
  }),

  getters: {
    getEventsLog: (state) => {
      return state.eventsLog;
    }
  },

  actions: {
    /**
     * GET /api/files/logs
     * Получить события
     * Поддерживает пагинацию, фильтрацию.
     */
    async getEventsLogQuery(page = 1, limit = 20, search = ""): Promise<EventLogResponse> {
      this.isLoadingEventsLog = true;

      const params = {
        page,
        limit,
        search
      };

      const response = await axios.get("/oracul/api/files/logs", { params });
      this.eventsLog = response.data;
      this.isLoadingEventsLog = false;

      return response.data;
    },

  },
});